export const WEAVE_SUPPORT_LINK = 'https://www.weavehelp.com/hc/en-us/p/contact-us';
export const SUBSCRIPTION_SETTINGS_PAGE_URL = '/home/dashboard#settings/subscriptions';
export const WEAVE_SUPPORT_CONTACT = '8885795668';
export const WEAVE_SUPPORT_CONTACT_IVR_EXTENSION = '1';
export const SUBSCRIPTION_SETTINGS_FF = 'settings:subscription';
export const HIDE_MANAGEMENT_AND_DETAILS_FF = 'subscription:hide-management-and-details';

export * from './feature-path-param';
export * from './feature-signup-data';
export * from './legal-terms';
